import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PLATFORM_API_URL } from '../constants';

@Injectable()
export class AuthorizationApiService {
  private readonly http = inject(HttpClient);
  private readonly platformApiUrl = inject(PLATFORM_API_URL);

  public isValidAuthorization(tenantLobProductId: string, memberId: string, authNumber: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.getBaseUrl()}/ExistsForMember/tenantLobProduct/${tenantLobProductId}/member/${memberId}/authorization/${authNumber}`
    );
  }

  private getBaseUrl(): string {
    return `${this.platformApiUrl}/api/Authorizations`;
  }
}
